(() => {
	angular.module('main').directive('snInputEmail', snInputEmail);

	snInputEmail.$inject = ['$rootScope'];

	function snInputEmail($rootScope) {
		return {
			restrict: 'AE',
			scope: {
				title: '@snTitle',
				model: '=snModel',
				snPlaceholder: '@',
				toggleCc: '=snShowCc'
			},
			template(element, attrs) {
				let template = '',
					toggleBtn = '';

				if (attrs.hasOwnProperty('snShowCc')) {
					toggleBtn =
						'<button type="button" class="btn btn-link color-java" ng-if="!toggleCc" ng-click="toggleViewCc()">Add Cc</button>';
					toggleBtn += '<b>toggleCc: {{toggleCc}}</b>';
				}

				template += '<div class="field-info">';
				template += '<h4>{{title}}</h4>';

				template += '<div class="flex-row">';
				template +=
					'<input class="form-control" type="email" placeholder="{{snPlaceholder}}"';
				template += 'ng-model="model" required maxlength="255">';
				template += toggleBtn;

				template += '</div>';
				template += '</div>';

				return template;
			},
			replace: true,
			link(scope, elem, attr, ctrl) {
				scope.toggleViewCc = function() {
					scope.toggleCc = !scope.toggleCc;
				};

				scope.$watch('toggleCc', (newValue, oldValue) => {
					if (newValue !== oldValue) {
						console.log('newValue', newValue);
						$rootScope.showCcField = newValue;
					}
				});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Filelds/snFieldEmail.js